var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8.75,
    fill: "#273848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 38.1263H44.375L46.4584 29.793H39.1667V25.6263C39.1667 23.4805 39.1667 21.4596 43.3334 21.4596H46.4584V14.4596C45.7792 14.3701 43.2146 14.168 40.5063 14.168C34.85 14.168 30.8334 17.6201 30.8334 23.9596V29.793H24.5834V38.1263H30.8334V55.8346H39.1667V38.1263Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookA);
export default __webpack_public_path__ + "static/media/facebook_a.c294ec1adebf0cbbc2a56b3a1984c828.svg";
export { ForwardRef as ReactComponent };